'use client';

// Re-export the shared WebSocket hook from context
// This ensures a single WebSocket connection is shared across all components
export { useWebSocket } from '@/contexts/WebSocketContext';
export type { UseWebSocketReturn } from '@/contexts/WebSocketContext';
